import type React from 'react';
import styled from 'styled-components';

export type NavigationCardRailProps = {
  children: React.ReactNode;
  className?: string;
};

const RailContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  width: 100%;
  gap: 1rem;
  
  ${({ theme: { media } }) => `${media.medium(
    () => `
      display: flex;
      flex-direction: row;
      align-items: stretch;
      
      > * {
        flex: 1;
        height: auto;
      }
    `,
  )}
  `};
`;

const NavigationCardContainer: React.FC<NavigationCardRailProps> = ({ children, className }) => {
  return <RailContainer className={className}>{children}</RailContainer>;
};

export default NavigationCardContainer;
